import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class Settings {
  private readonly http = inject(HttpClient);

  updateUser(userId: string, user: any): Observable<any> {
    return this.http.put<any>(`${environment.apiPrefix}${environment.user.user}/${userId}`, user);
  }
}
